/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Login } from './Login';
import { Registration } from './Registeration';
import { ForgotPassword } from './ForgotPassword';
// import { toAbsoluteUrl } from '_metronic/helpers';
import { RegisterNewUser } from './RegisterNewUser';
import './AuthPager.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './tostifyOverrideScss.scss';
import { toAbsoluteUrl } from '_metronic/helpers';

export function AuthPage() {
  useEffect(() => {
    document.body.classList.add('bg-white');
    return () => {
      document.body.classList.remove('bg-white');
    };
  }, []);
  const [logo, setLogo] = useState(toAbsoluteUrl('/media/logos/icon.png'));
  const [canSignUp, setSignUp] = useState(true);

  useEffect(() => {
    const url = new URL(window.location.href);
    const host = url?.host || '';
    if (host === 'fms.nchhd.org') {
      setLogo(
        'https://supista-app-logos.s3.ap-south-1.amazonaws.com/nchhdgjywodkneemzpiw/app-logo.png'
      );
      setSignUp(false);
    }
  }, []);
  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-cover bgi-attachment-fixed AuthPage'
      // style={{
      //   backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/authbg.png')})`,
      // }}
    >
      <ToastContainer position={'bottom-left'} theme={'colored'} />

      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo */}
        <a href='#' className='mb-12'>
          <img alt='Logo' src={logo} className='h-45px' />
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='w-lg-500px w-md-500px w-sm-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
          <Switch>
            <Route path='/auth/login' component={Login} />
            {canSignUp && <Route path='/auth/registration' component={Registration} />}
            <Route path='/auth/forgot-password' component={ForgotPassword} />
            <Route path='/auth/change-password' component={ForgotPassword} />
            <Route path='/:appID/registerNewUser/:secretLoginKey' component={RegisterNewUser} />
            <Redirect from='/auth' exact={true} to='/auth/login' />
            <Redirect to='/auth/login' />
          </Switch>
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      {/* <div className='d-flex flex-center flex-column-auto p-10'>
        <div className='d-flex align-items-center fw-bold fs-6'>
          <a href='#' className='text-muted text-hover-primary px-2'>
            About
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact
          </a>

          <a href='#' className='text-muted text-hover-primary px-2'>
            Contact Us
          </a>
        </div>
      </div> */}
      {/* end::Footer */}
    </div>
  );
}
